export const GET_SMS = 'admin/GET_SMS';
export const GET_SMS_SUCCESS = GET_SMS+'_SUCCESS';
export const GET_SMS_FAILURE = GET_SMS+'_FAILURE';
